<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список ПО/ОС</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить</li>
        </ol>
    </nav>

    <div class="form-body">
        <div class="form-narrow mb-4">
            <div class="mb-4">
                <label class="form-label">Название ПО <span class="color-red">*</span></label>
                <input type="text" class="form-control" v-model="formData.name">
            </div>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Добавить'" @btnClick="create"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';
import DeviceSoftware from '../../../../models/DeviceSoftware';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'DeviceSoftwareCreateComponent',
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_create: String
    },
    data: function () {
       return {
           deviceSoftware: new DeviceSoftware({
               route_create: this.route_create
           }),
           formData: {
               name: ''
           },
       }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),

        create: async function () {
            if (this.formData.name === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите название ПО/ОС!' });
                this.toggleLoading();
                return;
            }
            let result = await this.deviceSoftware.create(this.formData);
            if(result) {
                window.location.href = this.route_back;
            } else {
                this.showError();
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Что-то пошло не так' });
                this.toggleLoading();
            }
        },
    },
}
</script>

<style scoped>

</style>
